import React, { useState, useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import { FieldError } from '../../../../../hybrid/wrappers';
import Title from '../../Title';
import css from './FormCheckboxList.module.scss';
import classnames from 'classnames';
import { generateCompStylers } from '../../../../../common/utils/styles';
import Checkbox from '../Checkbox/Checkbox';

const FormCheckboxList = ({
    attribute,
    options,
    disabled,
    title,
    handlers = {},
    compStyle,
    value,
    setFormData,
    errors,
    hardUpdate
}) => {
    const { stylers, classes } = generateCompStylers(compStyle);
    const [val, setVal] = useState(value || false);
    const changeHandler = useCallback(
        (i) => {
            if (!disabled) {
                setVal((pre) => {
                    let newArr = pre.map((item) => {
                        if (i === item.id) {
                            return { ...item, value: !item.value };
                        }
                        return item;
                    });
                    if (handlers?.onChange) handlers?.onChange(newArr);
                    setFormData(attribute, newArr);
                    return newArr;
                });
            }
        },
        [disabled, handlers, val, attribute, setFormData]
    );
    useEffect(() => {
        setFormData(attribute, val);
    }, []);

    useEffect(() => {
        if (hardUpdate) {
            setVal(value);
        }
    }, [hardUpdate, value]);

    return (
        <div style={stylers.wrapper} className={classnames(css.formCheckboxWrapper, classes.wrapper)}>
            {!!title && (
                <div style={stylers.listTitle} className={classnames(css.formCheckboxlistTitle, classes.listTitle)}>
                    <Title Comp={'p'} body={title.body} links={title.links} />
                </div>
            )}
            {val?.map((option, i) => {
                const optionTitle = options.find((item) => item.id === option.id)
                    ? options.find((item) => item.id === option.id)?.title
                    : '';
                const optionDisabled = options.find((item) => item.id === option.id)?.disabled;
                return (
                    <div key={`optionTitle_${i}`} style={stylers.listItem} className={classnames(classes.listItem, css.listItem)}>
                        <div
                            onClick={() => {
                                if (optionDisabled) return;
                                changeHandler(option.id);
                            }}
                            style={stylers.label}
                            className={classnames(
                                css.formCheckboxBlock,
                                disabled || optionDisabled ? css.formCheckboxBlockDisabled : {},
                                classes.label,
                                { [css.formCheckboxBlockActive]: option.value }
                            )}
                        >
                            <Checkbox isActive={option.value} />
                            {!!optionTitle && <Title Comp={'p'} body={optionTitle} />}
                        </div>
                    </div>
                );
            })}
            {errors && errors.length ? errors.map((err, idx) => <FieldError key={`${attribute}${idx}`}>{err}</FieldError>) : null}
        </div>
    );
};
FormCheckboxList.propTypes = {
    attribute: PropTypes.string,
    options: PropTypes.array,
    disabled: PropTypes.bool,
    title: PropTypes.object,
    handlers: PropTypes.object,
    compStyle: PropTypes.object,
    value: PropTypes.array,
    setFormData: PropTypes.func,
    errors: PropTypes.array
};
export default FormCheckboxList;
